import { createContext, useContext } from "react";

/** Interface */
interface ITreeContext<U> {
	append: (data: U, parentId?: string) => string | null;
}

/** Context */
export const TreeContext = createContext<ITreeContext<unknown>>({} as ITreeContext<unknown>);

/** Hooks */
export function useTreeContext<U>() {
	return useContext(TreeContext) as ITreeContext<U>;
}
